import { PAGE_BREAK } from '@root/helpers/editor';

export const hasPageBreak = (html: string) => PAGE_BREAK.test(html);

/** The raw (untrimmed) parts of a block's content between its page breaks. */
export const splitAtPageBreaks = (html: string): string[] => html.split(PAGE_BREAK);

export const getPageParts = (html: string, hasBreakAfter: boolean) => {
  const parts = splitAtPageBreaks(html).map((part) => part.trim());
  if (hasBreakAfter && parts.length > 1 && parts.at(-1) === '<p></p>') parts[parts.length - 1] = '';
  return parts;
};
